// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid-card:nth-of-type(4n+1),.grid-card:nth-of-type(4n+4){grid-column:span 12/span 12}@media (min-width:640px){.grid-card:nth-of-type(4n+1),.grid-card:nth-of-type(4n+4){grid-column:span 7/span 7}}.grid-card:nth-of-type(4n+2),.grid-card:nth-of-type(4n+3){grid-column:span 12/span 12}@media (min-width:640px){.grid-card:nth-of-type(4n+2),.grid-card:nth-of-type(4n+3){grid-column:span 5/span 5}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
